const AbstractAuthenticationView = require("./AbstractAuthenticationView");
const Utils = require("common/Utils");

function LogonMessageView() {
    AbstractAuthenticationView.call(this);
    const self = this;
    const $content = $(require("html!./logon_message_view_content.html"));
    const $returnButton = $content.find("#footerBtnLoginMsgPage");

    this.setInnerContent($content);

    $returnButton.on("click", function() {
        self.publishEvent("LogonController", "logoff-user");
    });

    this.setMessage = function(key, message, noReturn) {
        $content.find("#loginResultMessage").text(message);

        $returnButton.off("click");
        if (key === "error.unsupportedClient.message") {
            $returnButton.on("click", function() {
                self.publishEvent("ConnectionController", "return-to-connection");
            });
        } else {
            $returnButton.on("click", function() {
                self.publishEvent("LogonController", "logoff-user");
            });
        }

        noReturn ? $returnButton.hide() : $returnButton.show();
    };
}

Utils.inherits(LogonMessageView, AbstractAuthenticationView);

module.exports = LogonMessageView;